import Vue from 'vue'

Vue.directive('observe', {
  bind (el, { value: observer }) {
    if (observer) {
      observer.observe(el)
    }
  }
})
